// extracted by mini-css-extract-plugin
export default {"container":"DashboardLayout_container__X5Inl","notificationError":"DashboardLayout_notificationError__az-h3"};